import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Col, Row, Form, Button} from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import StudentService from '../../../service/studentService';
import StudentCourseService from '../../../service/studentCourseService';
import CourseService from '../../../service/courseService';
import CourseStudent from '../../../components/CourseStudent/CourseStudent';
import ReactTooltip from 'react-tooltip';
import useToken from '../../../App/useToken';
import 'react-toastify/dist/ReactToastify.css';
import './Student.css';

function EditStudent() {
  const { getUser, getToken, getUnit, getRole } = useToken();
  const token = getToken();
  const user = getUser();
  const tokenUnit = getUnit();
  const role = getRole();
  const eclRef = useRef();
  const healthRef = useRef();
  const secretLayerRef = useRef();
  const { id } = useParams();
  const [name, setName] = useState();
  const [fullName, setFullName] = useState();
  const [citizenId, setCitizenId] = useState();
  const [eclFile, setEclFile] = useState();
  const [healthFile, setHealthFile] = useState();
  const [secretLayerFile, setSecretLayerFile] = useState();
  const [unit, setUnit] = useState();
  
  const [studentCourses, setStudentCourses] = useState([]);

  const [eclFileUpload, setEclFileUpload] = useState();
  const [eclScore, setEclScore] = useState();
  const [healthFileUpload, setHealthFileUpload] = useState();
  const [secretLayerFileUpload, setSecretLayerFileUpload] = useState();

  const getStudentInfo = async () => {
    const studentService = new StudentService();
    const res = await studentService.getStudentById(id, token);
    if (res?.name) {
      setName(res.name);
      setFullName(`${res.rank}${res.name} ${res.surname}`);
      setCitizenId(res.citizenId);
      setEclFile(res.eclFile);
      setHealthFile(res.healthFile);
      setSecretLayerFile(res.secretLayerFile);
      setUnit(res.unit);
      setEclScore(res.ecl);
    }
    return(res);
  }

  useEffect(() => {
    if (user) {
      getStudentInfo(id);
    }
  }, []);

  useEffect(async () => {
    if (citizenId) {
      const studentCourseService = new StudentCourseService();
      const res = await studentCourseService.getCourseByCitizenId(citizenId, token);
      setStudentCourses(res);
    }
  }, [citizenId]);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [healthFile, secretLayerFile]);

  const fileUploadNotifyError = () => {
    toast.error('กรุณาเลือกไฟล์แนบ', {
      theme: 'dark'
    })
  }
  const fileUploadNotifySuccess = () => {
    toast.success('แนบไฟล์สำเร็จ', {
      theme: 'dark'
    })
  }

  const alertError = (msg) => {
    toast.error(msg, {
      theme: 'dark'
    })
  }
  const notifySuccess = (msg) => {
    toast.success(msg, {
      theme: 'dark'
    })
  }

  const handleSubmitEclScore = async e => {
    e.preventDefault();
    const studentService = new StudentService();
    await studentService.updateStudentEclScore(id, eclScore, token)
      .then(data => { 
        notifySuccess('แก้ไขสำเร็จ')
      })
      .catch(err => alertError(err.message))
  };

  const handleSubmitFile = async e => {
    e.preventDefault();
    const res = null;
    const studentService = new StudentService();
    if (eclFileUpload) {
      await studentService.updateStudentFile(id, { file: eclFileUpload, name: 'ecl' }, token).then(res => {
        eclRef.current.value = "";
        setEclFileUpload();
        getStudentInfo(id);
        fileUploadNotifySuccess();
      });
      
    } else if(healthFileUpload) {
      await studentService.updateStudentFile(id, { file: healthFileUpload, name: 'health' }, token).then(res => {
        healthRef.current.value = "";
        setHealthFileUpload();
        getStudentInfo(id);
        fileUploadNotifySuccess();
      });;
    } else if(secretLayerFileUpload) {
      await studentService.updateStudentFile(id, { file: secretLayerFileUpload, name: 'secretLayer' }, token).then(res => {
        secretLayerRef.current.value = "";
        setSecretLayerFileUpload();
        getStudentInfo(id);
        fileUploadNotifySuccess();
      });;
    } else {
      fileUploadNotifyError();
    }
  }

  const handleDowloadFile = async name => {
    console.log('name :>> ', name);
    if (name) {
      const courseService = new CourseService();
      const dowloadLink = await courseService.dowloadFile('eclScore', name);
      window.open(dowloadLink);
    }
  }


  return (
    <div>
      <Container className='student-wrapper'>
        <ReactTooltip />
        { name && 
          <Row>
            <Col lg={2} md={2} sm={12}>
              <Row>
                <div className='img-container'>
                  <img className='profile-img' src={'https://pbs.twimg.com/media/E0_ZBRqUcAE0pLc.jpg'} />
                </div>
              </Row>
            </Col>
            <Col lg={10} md={10} sm={12}>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3} md={10} sm={12}>{fullName}</Col>
                <Col className='background-border' lg={3} md={10} sm={12}>เหล่า: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ระยะเวลาครองยศปัจจุบัน: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3} md={10} sm={12}>ตำแหน่ง: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ลชทอ.หลัก: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ระบุแผนอัตราการเข้าของหน่วย: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3} md={10} sm={12}>สังกัด: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ลชทอ.รอง1: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>คะแนนประเมินล่าสุด: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3} md={10} sm={12}>สายวิทยาการ: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ลชทอ.รอง2: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ผลสอบภาษาอังกฤษ: </Col>
              </Row>
              <Row style={{ height: '45px' }} className={window.innerWidth <= 1200 && 'medium-size'}>
                <Col className='background-border' lg={3} md={10} sm={12}>ผลตรวจร่างกาย: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>ผลรับรองการเข้าถึงชั้นความลับ: </Col>
                <Col className='background-border' lg={3} md={10} sm={12}>อายุ: </Col>
              </Row>
              <Row className={window.innerWidth <= 1200 && 'medium-size'}>
                  <Col className='import-file-container' lg={3} md={10} sm={12}>
                    <Form onSubmit={handleSubmitFile}>
                      <Form.Group as={Col} controlId="ecl" onChange={e => setEclFileUpload(e.target.files[0])}>
                        <Form.Label>แนบผลสอบภาษาอังกฤษ</Form.Label>
                        <Form.Control ref={eclRef} type="file" multiple />
                      </Form.Group>
                      <Row>
                        <Col className='file-name' md={6}>
                          <span className='dowload-file' onClick={e => handleDowloadFile(eclFile)} data-tip={eclFile}>{eclFile}</span>
                        </Col>
                        <Col md={6}>
                          <Button variant="success btn-sm" type="submit">
                            แก้ไข
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                  <Col className='import-file-container' lg={3} md={10} sm={12}>
                    <Form onSubmit={handleSubmitFile}>
                      <Form.Group as={Col} controlId="health" onChange={e => setHealthFileUpload(e.target.files[0])}>
                        <Form.Label>ผลรับรองการตรวจร่างกาย</Form.Label>
                        <Form.Control ref={healthRef} type="file" multiple />
                      </Form.Group>
                      <Row>
                        <Col className='file-name' md={6}>
                          <span className='dowload-file' onClick={e => handleDowloadFile(healthFile)} data-tip={healthFile}>{healthFile}</span>
                        </Col>
                        <Col md={6}>
                          <Button variant="success btn-sm" type="submit">
                            แก้ไข
                          </Button>
                        </Col>
                      </Row>
                    </Form>                  
                  </Col>
                  <Col className='import-file-container' lg={3} md={10} sm={12}>
                    <Form onSubmit={handleSubmitFile}>
                      <Form.Group as={Col} controlId="secretLayer" onChange={e => setSecretLayerFileUpload(e.target.files[0])}>
                        <Form.Label>ผลรับรองการเข้าถึงชั้นความลับ</Form.Label>
                        <Form.Control ref={secretLayerRef} type="file" multiple />
                      </Form.Group>
                      <Row>
                        <Col className='file-name' md={6}>
                          <span className='dowload-file' onClick={e => handleDowloadFile(secretLayerFile)} data-tip={secretLayerFile}>{secretLayerFile}</span>
                        </Col>
                        <Col md={6}>
                          <Button variant="success btn-sm" type="submit">
                            แก้ไข
                          </Button>
                        </Col>
                      </Row>
                    </Form>                  
                  </Col>
              </Row>
              { (role != 'student' && unit === tokenUnit) && <Row className={window.innerWidth <= 1200 && 'medium-size'}>
                  <Col className='import-file-container' lg={3} md={10} sm={12}>
                    <Form onSubmit={handleSubmitEclScore}>
                      <Form.Group as={Col} controlId="eclScore" onChange={e => setEclScore(e.target.value)}>
                        <Form.Label>คะแนนสอบภาษาอังกฤษ</Form.Label>
                        <Form.Control type="number" value={eclScore} />
                      </Form.Group>
                      <Row>
                        <Col md={12}>
                          <Button variant="success btn-sm" type="submit">
                            แก้ไข
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
              </Row> }
            </Col>
          </Row>
        }
        { name && studentCourses && <CourseStudent studentCourses={studentCourses} />
        }
      </Container>
    </div>
  )
};


export default EditStudent;
